import { native } from '@forest/native-services'
import { shouldMockAPI } from './params'

const cache = new Map<string, Promise<string | null>>()

// The MSW fixtures' backend title keys, so `?mock` dev (no bridge) still
// shows names for server-derived reveal content.
const MOCK_TITLES: Record<string, string> = {
  tree_type_9_title: 'Pine Tree',
  landskin_5_title: 'Meadow',
}

/**
 * Resolves a backend `title_key` through the native l10n table (the keys
 * belong to the mobile app's translations, not this web app's). Returns null
 * when the key cannot be resolved.
 */
export function getLocalizedMessage(key: string): Promise<string | null> {
  if (!key) return Promise.resolve(null)
  if (import.meta.env.DEV && shouldMockAPI) {
    return Promise.resolve(MOCK_TITLES[key] ?? null)
  }
  const cached = cache.get(key)
  if (cached) return cached
  const promise = native.l10n
    .getLocalizedString({ key })
    .then((value) => (value === key ? null : value))
    .catch((err: unknown) => {
      cache.delete(key)
      throw err
    })
  cache.set(key, promise)
  return promise
}
